import { useCallback } from "react";
import axios from "axios";
import { BASE_URL } from "./../../Config/Config";
import toast from "react-hot-toast";
import { setLoader } from "./../../Redux/Slice/loaderSlice";
import { useSelector } from "react-redux";
import { setLogin, setUser } from "../../Redux/Slice/userSlice";
import { useNavigate } from "react-router-dom";

export const useAdminVacation = () => {
  const navigate = useNavigate();
  const alertBox = (text) => {
    return toast.error(text);
  };

  const userData = useSelector((state) => state.user.data);

  const Headers = {
    "Admin-Api-Key": userData.token,
  };

  //Get all vacation
  const getAllVacations = useCallback(async (body, dispatch) => {
    dispatch(setLoader(true));
    try {
      const { data } = await axios.post(
        `${BASE_URL.BASE_API_URL}admin/company/vacations`,
        body,
        {
          headers: {
            ...Headers,
          },
        }
      );
      if (data.error) {
        alertBox(data.msg);
      }
      dispatch(setLoader(false));
      return data.data;
    } catch (error) {
      dispatch(setLoader(false));
      if (error.response && error.response.status === 401) {
        alertBox(error.response.data.msg);
        dispatch(setLogin(false));
        dispatch(setUser({}));
        navigate("/login");
        window.localStorage.removeItem("ts_invoices");
      } else {
        alertBox(error.message);
      }
    }
  }, []);

  //delete vacation
  const changeStatus = useCallback(async (body, dispatch) => {
    dispatch(setLoader(true));
    try {
      const { data } = await axios.post(
        `${BASE_URL.BASE_API_URL}admin/company/vacation/status`,
        { id: body.id, status: body.status },
        {
          headers: {
            ...Headers,
          },
        }
      );
      if (data.error) {
        alertBox(data.msg);
      }
      dispatch(setLoader(false));
      return data.meta;
    } catch (error) {
      dispatch(setLoader(false));
      if (error.response && error.response.status === 401) {
        alertBox(error.response.data.msg);
        dispatch(setLogin(false));
        dispatch(setUser({}));
        navigate("/login");
        window.localStorage.removeItem("ts_invoices");
      } else {
        alertBox(error.message);
      }
    }
  }, []);

  return {
    getAllVacations,
    changeStatus,
  };
};
